/* TOPSAFE — selector de talla en la tarjeta de producto.
   Elegir talla carga el id de la variante en el form y habilita el botón;
   el envío lo hace <product-form> del theme (cart drawer incluido). */
if (!customElements.get('tsc-quick-sizes')) {
  customElements.define('tsc-quick-sizes', class TscQuickSizes extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      if (!this.form) return;
      this.input = this.form.querySelector('input[name="id"]');
      this.submit = this.form.querySelector('.tsc-qs__add');
      this.label = this.submit && this.submit.querySelector('.tsc-qs__label');
      this.addEventListener('click', this.onClick.bind(this));
    }

    onClick(evt) {
      const btn = evt.target.closest('.tsc-qs__size');
      if (!btn || btn.disabled) return;
      this.querySelectorAll('.tsc-qs__size[aria-pressed="true"]').forEach((b) => b.setAttribute('aria-pressed', 'false'));
      btn.setAttribute('aria-pressed', 'true');
      this.input.value = btn.dataset.variantId;
      if (!this.submit) return;
      this.submit.disabled = false;
      this.submit.removeAttribute('aria-disabled');
      if (this.label) this.label.textContent = `${this.submit.dataset.labelReady} · talla ${btn.dataset.size}`;
    }
  });
}

/* Ventana "¿Cuál es mi talla?": botones con [data-tsc-size-guide] abren
   el <dialog id="tsc-size-guide"> que renderiza layout/theme.liquid. */
document.addEventListener('click', (evt) => {
  const dlg = document.getElementById('tsc-size-guide');
  if (!dlg || typeof dlg.showModal !== 'function') return;
  const opener = evt.target.closest('[data-tsc-size-guide]');
  const tab = evt.target.closest('[data-sg-tab]');
  const show = (key) => {
    const brand = key === 'hombre' || key === 'mujer';
    dlg.querySelectorAll('[data-sg-panel]').forEach((p) => { p.hidden = p.dataset.sgPanel !== key; });
    dlg.querySelectorAll('[data-sg-tab]').forEach((t) => t.setAttribute('aria-selected', String(t.dataset.sgTab === key)));
    dlg.querySelectorAll('.tsc-sg__tabs, .tsc-sg__brand').forEach((el) => { el.hidden = !brand; });
  };
  if (tab) { show(tab.dataset.sgTab); return; }
  if (opener) {
    evt.preventDefault();
    const key = opener.getAttribute('data-tsc-size-guide');
    show(key === 'mujer' || key === 'general' ? key : 'hombre');
    dlg.showModal();
  } else if (evt.target.closest('[data-tsc-size-guide-close]') || evt.target === dlg) {
    dlg.close();
  }
});

/* Aviso de despacho el mismo día según la hora de Chile. */
if (!customElements.get('tsc-sameday')) {
  customElements.define('tsc-sameday', class TscSameday extends HTMLElement {
    connectedCallback() {
      this.text = this.querySelector('.tsc-sameday__text');
      this.cutoff = parseInt(this.dataset.cutoff || '11', 10);
      this.days = (this.dataset.days || '1,2,3,4,5').split(',').map(Number);
      this.update();
      this.timer = setInterval(() => this.update(), 60000);
    }

    disconnectedCallback() { clearInterval(this.timer); }

    nowInSantiago() {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Santiago', weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23'
      }).formatToParts(new Date());
      const get = (t) => parts.find((p) => p.type === t).value;
      const wd = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(get('weekday'));
      return { day: wd, minutes: parseInt(get('hour'), 10) * 60 + parseInt(get('minute'), 10) };
    }

    update() {
      if (!this.text) return;
      let now;
      try { now = this.nowInSantiago(); } catch (e) { return; }
      const cut = this.cutoff * 60;
      if (this.days.includes(now.day) && now.minutes < cut) {
        const left = cut - now.minutes;
        const h = Math.floor(left / 60);
        const m = left % 60;
        const time = h > 0 ? `${h} h ${m} min` : `${m} min`;
        this.text.innerHTML = `<strong>Despacho HOY en Santiago</strong> · compra en las próximas ${time}`;
        this.classList.add('is-today');
        return;
      }
      this.classList.remove('is-today');
      const names = ['el domingo', 'el lunes', 'el martes', 'el miércoles', 'el jueves', 'el viernes', 'el sábado'];
      for (let i = 1; i <= 7; i++) {
        const d = (now.day + i) % 7;
        if (this.days.includes(d)) {
          const when = i === 1 ? 'mañana' : names[d];
          this.text.innerHTML = `Compra ahora y <strong>despachamos ${when}</strong> en Santiago (compras antes de las ${this.cutoff}:00 salen el mismo día)`;
          return;
        }
      }
    }
  });
}
